import React from 'react'

import "./table.css";

const THead = ({headItems}) => {
  return (
    <>
        <div className="table-head">
            <ul>
              {headItems.map((item,index)=>{
                return <li key={index}>{item}</li>
              })}
            </ul>
            <div className="line"></div>
          </div>
    </>
  )
}

export default THead